const UseUtilities = () => {
  const sortByPropertyAsc = (property) => {
    return function (a, b) {
      if (a[property] > b[property]) {
        return 1;
      } else if (a[property] < b[property]) {
        return -1;
      }
      return 0;
    };
  };

  const sortByPropertyAscDouble = (property) => {
    return function (a, b) {
      // Determinar el valor a usar para cada producto
      const valueA = a.front ? a.front[property] : (a.rear ? a.rear[property] : '');
      const valueB = b.front ? b.front[property] : (b.rear ? b.rear[property] : '');
      
      // Verificar si ambos tienen front o rear para determinar la prioridad
      const hasFrontA = Boolean(a.front);
      const hasFrontB = Boolean(b.front);
      
      // Si uno tiene neumático delantero y el otro no, priorizar el que lo tiene
      if (hasFrontA && !hasFrontB) return -1; // A tiene front, B no - A va primero
      if (!hasFrontA && hasFrontB) return 1;  // B tiene front, A no - B va primero
      
      // Si ambos tienen o no tienen front, comparar por el valor determinado
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return valueA.localeCompare(valueB); // Comparación segura para strings
      }
      
      // Para tipos no string, comparación con seguridad para null/undefined
      if (valueA === valueB) return 0;
      if (valueA === null || valueA === undefined) return 1; // Valores null/undefined van al final
      if (valueB === null || valueB === undefined) return -1;
      
      // Comparación numérica normal
      return valueA < valueB ? -1 : 1;
    };
  };

  const orderByDefaultQuantityPlpDouble = (data) => {
    const criteriaOrderPlpDouble = {
      "2-2": [],
      "2-1": [],
      "1-2": [],
      "2-0": [],
      "0-2": [],
      "1-1": [],
      "1-0": [],
      "0-1": [],
    };

    data.forEach((item) => {
      if (item.front && item.rear) {
        const frontQuantity = item.front.valor_por_defecto_plp_doble ?? 0;
        const rearQuantity = item.rear.valor_por_defecto_plp_doble ?? 0;
        const key = `${frontQuantity}-${rearQuantity}`;
        criteriaOrderPlpDouble[key].push(item);
      }
    });

    sortGroupedBrandPlpDoubleData(criteriaOrderPlpDouble);

    return flattenGroupedPlpDoubleData(criteriaOrderPlpDouble);
  };

  const flattenGroupedPlpDoubleData = (groupedData) => {
    return Object.values(groupedData).flat();
  };

  const sortGroupedBrandPlpDoubleData = (groupedData) => {
    for (const groupKey in groupedData) {
      groupedData[groupKey].sort((a, b) => {
        if (a.front.trimarca === "NO" && b.front.trimarca !== "NO") {
          return 1;
        }
        if (a.front.trimarca !== "NO" && b.front.trimarca === "NO") {
          return -1;
        }
        return 0;
      });
    }
  };

  const sortByPropertyDesc = (property) => {
    return function (a, b) {
      if (a[property] < b[property]) {
        return 1;
      } else if (a[property] > b[property]) {
        return -1;
      }
      return 0;
    };
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const formattedPrice = (valor) => {
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }).format(valor);
  };

  function formatNumberPhone(number) {
    const phone = String(number);
    const length = phone.length;
    let formattedPhone = "";

    for (let i = 1; i <= length; i++) {
      formattedPhone = phone[length - i] + formattedPhone;
      if (i % 4 === 0 && i !== length) {
        formattedPhone = " " + formattedPhone;
      }
    }

    return formattedPhone;
  }

  const addFinalPrice = (products) => {
    return products.map((productItem) => {

      // CLONADO SEGURO PARA OBJETOS REACTIVOS
      const clonedProduct = { ...productItem }

      const product = ref(clonedProduct)
      const quantity = ref(1)

      const { precio_unitario, onProductChange } = useProductPricing(product, quantity)

      onProductChange(product)

      clonedProduct.final_price = precio_unitario.value

      return clonedProduct
    })
  }

  const InternaupdateFinalPrice = (productItem) => {
    if (productItem) {
      const product = ref(productItem);
      const { precio_unitario, onProductChange } = useProductPricing(product, ref(1));

      onProductChange(product);
      productItem.final_price = precio_unitario.value;
    }
  };

  const addFinalPriceDouble = (products) => {
    return products.map((item) => {

      const cloned = {
        ...item,
        front: item.front ? { ...item.front } : null,
        rear: item.rear ? { ...item.rear } : null,
      }

      if (cloned.front) {
        InternaupdateFinalPrice(cloned.front)
      }

      if (cloned.rear) {
        InternaupdateFinalPrice(cloned.rear)
      }

      return cloned
    })
  }



  return {
    sortByPropertyAsc,
    sortByPropertyDesc,
    capitalizeFirstLetter,
    formattedPrice,
    formatNumberPhone,
    addFinalPrice,
    addFinalPriceDouble,
    sortByPropertyAscDouble,
    orderByDefaultQuantityPlpDouble,
  };
};

export default UseUtilities;
